<header
  class="sticky top-0 z-99999 flex w-full border-b border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900"
>
  <div class="flex grow items-center justify-between px-4 py-3 sm:px-6 lg:py-4">
    <div class="flex items-center gap-2 sm:gap-4">
      <button
        class="z-99999 flex h-10 w-10 items-center justify-center rounded-lg border-gray-200 text-gray-500 lg:h-11 lg:w-11 xl:border dark:border-gray-800 dark:text-gray-400"
        [ngClass]="{
          'bg-gray-100 dark:bg-white/3': isMobileOpen$ | async,
        }"
        (click)="handleToggle()"
        aria-label="Toggle Sidebar"
      >
        @if (isMobileOpen$ | async) {
          <ng-icon name="hugeCancel01" size="24" class="text-current" />
        } @else {
          <ng-icon name="hugeMenu01" size="16" class="text-current" />
        }
      </button>
      <img
        src="/images/logo/logo.png"
        alt="Logo SIAE"
        class="block h-10 w-auto lg:h-11 xl:hidden"
      />
    </div>

    <div class="flex items-center gap-4">
      <!-- UserComponent always visible -->
      <app-user />

      <button
        (click)="logout()"
        [disabled]="isLoggingOut()"
        class="flex h-10 w-10 items-center justify-center rounded-lg border-gray-200 text-gray-500 hover:bg-gray-100 lg:h-11 lg:w-11 xl:border dark:border-gray-800 dark:text-gray-400 dark:hover:bg-gray-800"
        aria-label="Logout"
      >
        <ng-icon name="hugeLogout01" size="20" class="text-current" />
      </button>
    </div>
  </div>
</header>
